import Text from "@pathwright/ui/src/components/ui/Text"
import View from "@pathwright/ui/src/components/ui/View"
import { BORDER_WHITE } from "@pathwright/ui/src/components/utils/colors"
import { WithCSS } from "@pathwright/ui/src/components/utils/styles"
import { Component } from "react"
import { css } from "styled-components"
import PathSteps from "./PathSteps"

export default class PathLesson extends Component {
  state = {
    load: false,
    expand: false
  }

  UNSAFE_componentWillMount() {
    if (this.props.initialExpand) {
      this.setState({ load: true, expand: true })
    }
  }

  componentWillUnmount() {
    clearTimeout(this.hover)
  }

  handleMouseLeave = () => {
    clearTimeout(this.hover)
  }

  handleMouseEnter = () => {
    if (!this.state.load) {
      this.hover = setTimeout(this.loadSteps, 400)
    }
  }

  loadSteps = () => {
    this.setState((s) => ({ load: true }))
  }

  toggleExpand = () => {
    this.loadSteps()
    this.setState((s) => ({ expand: !s.expand }))
  }

  render() {
    const { source_id, path_id, name, description, items } = this.props.lesson
    return (
      <WithCSS as={View} css={styles.wrapper} className="path-lesson">
        <WithCSS as={View} css={styles.pathLine} className="path-line" />
        <WithCSS
          as={View.Primary}
          css={styles.container}
          onClick={this.toggleExpand}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        >
          <WithCSS as="header" css={styles.header}>
            <Text.H4 style={{ marginBottom: 10, fontSize: "19px" }}>{name}</Text.H4>
            <Text.Body>{description}</Text.Body>
          </WithCSS>
          <PathSteps
            lessonSourceId={this.state.load ? source_id : null}
            pathId={path_id}
            propsLesson={this.props.lesson}
            schoolId={this.props.lesson.context.school_id}
            total={items.length}
            expand={this.state.expand}
            onEnterStep={this.props.onEnterStep}
          />
        </WithCSS>
        <WithCSS as={View} css={styles.pathLine} className="path-line" />
      </WithCSS>
    )
  }
}

PathLesson.displayName = "PathLesson"

const styles = {
  wrapper: css`
    display: flex;
    align-items: center;
    flex-direction: column;
  `,
  pathLine: css`
    width: 2px;
    height: 10px;
    background-color: ${BORDER_WHITE};
  `,
  container: css`
    width: 100%;
    margin: 10px auto;
    max-width: 600px;
    border-radius: 10px;
    cursor: pointer;
  `,
  header: css`
    padding: 20px;
    text-align: center;
    border-radius: 10px 10px 0 0;
  `
}
